"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let FarmSelectorModal = class FarmSelectorModal extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.selected = null;
    }
    dismissModal() {
        this.$emit('dismissModal');
    }
    get options() {
        return this.farmsAvailable.map((f) => {
            return Object.assign(Object.assign({}, f), { label: f.name, acreage: f.acreage.shortLabel });
        });
    }
    updateFarmSelected(model) {
        this.selected = this.farmsAvailable.find((f) => f.id === model.id);
    }
    changeFarm() {
        this.$emit('changeFarm', this.selected);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], FarmSelectorModal.prototype, "farmsAvailable", void 0);
FarmSelectorModal = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            Modal: bmk_ui_framework_1.Modal,
            CheckRoundedIcon: bmk_ui_framework_1.CheckRoundedIcon,
            Button: bmk_ui_framework_1.Button,
            Loading: bmk_ui_framework_1.Loading,
            Select: bmk_ui_framework_1.Select
        },
    })
], FarmSelectorModal);
exports.default = FarmSelectorModal;
